import { type components } from '@libraries/typescript/api_client';

export type SandboxRunFile = components['schemas']['SandboxRunFileRead'];
export type SandboxFileFolder = {
    readonly name: string;
    readonly path: string;
    readonly folders: Map<string, SandboxFileFolder>;
    readonly files: Array<SandboxRunFile>;
};

export function buildSandboxFileTree(
    files: ReadonlyArray<SandboxRunFile>,
): SandboxFileFolder {
    const root: SandboxFileFolder = {
        name: '/workspace',
        path: '/workspace/',
        folders: new Map(),
        files: [],
    };
    for (const file of files) {
        const parts = file.path
            .replace(/^\/workspace\//u, '')
            .split('/')
            .filter(Boolean);
        let folder = root;
        for (const name of parts.slice(0, -1)) {
            let child = folder.folders.get(name);
            if (!child) {
                child = {
                    name,
                    path: `${folder.path}${name}/`,
                    folders: new Map(),
                    files: [],
                };
                folder.folders.set(name, child);
            }
            folder = child;
        }
        folder.files.push(file);
    }
    return root;
}
